import React, {useContext, useState} from 'react';
import {useHistory} from 'react-router-dom'

export const TeamsPageEmployeeList = ({employee}) => {
    const history = useHistory()

    const handleEmployeeClick = (id) => {
        history.push(`/programs/employees/${id}`)
    }

    return (
        <div className="teams-page-employee-list" key={employee.id} onClick={() => {handleEmployeeClick(employee.id)}} style={{height: 46, marginBottom: 5, width: '100%'}}>
            <div style={{ paddingLeft: 10, paddingRight: 20, width: '100%', height: 46, display: 'flex' }}>
                <span style={{ height: 46, justifyContent: 'center', maxWidth: 46, width: '15%', display: 'flex', textAlign: 'center', alignItems: 'center'}}>
                    <div style={{ width: 36, height: 36, borderRadius: 18, alignItems: 'center', fontStyle: 'SGProText-Regular', fontSize: 20, color: 'white', fontWeight: 'bold', justifyContent: 'center', backgroundColor: 'rgba(128, 149, 167, 1)', display: 'flex'}}>
                        {employee.firstName.charAt(0).toUpperCase()}
                    </div>
                </span>
                <span style={{fontStyle: 'SGProText-Regular', width: '40%', fontSize: 13, marginLeft: 5, height: 46, display: 'flex', alignItems: 'center'}}>
                    {(employee.firstName).charAt(0).toUpperCase() + (employee.firstName).slice(1) + " " + (employee.lastName).charAt(0).toUpperCase() + (employee.lastName).slice(1)}
                </span>
                <span style={{fontStyle: 'SGProText-Light', fontSize: 12, color: 'rgba(0, 0, 0, 0.5)', width: '50%', height: 46, display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                    {employee.email}
                </span>
            </div>
        </div>
    )
}